import { ValidatorFn, Validators } from '@angular/forms';
import { plNotBlankValidator } from './not-blank.validator';

export const PL_ONLY_NUMBER_REGEX: RegExp = /^[0-9]+$/;
export const PL_NAME_REGEX: RegExp = /^[A-Za-zÀ-ÖØ-öø-ÿ.,'’‘\- ]+$/;
export const PL_EMAIL_REGEX: RegExp =
  /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,12}$/;
export const PL_PHONE_REGEX: RegExp =
  /^(\+\d{1,2}\s)?((\(\d{3}\))|(\d{3}))[\s.-]?\d{3}[\s.-]\d{4}$/;
export const PL_ZIP_CODE_REGEX: RegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const PL_TIME_REGEX: RegExp =
  /^(0?[1-9]|1[0-2]):([0-5]\d)\s?((?:A|P)\.?M\.?)$/;

export const plNameValidators: ValidatorFn[] = [
  Validators.required,
  Validators.maxLength(64),
  Validators.pattern(PL_NAME_REGEX),
  plNotBlankValidator,
];

export const plPercentageValidators: ValidatorFn[] = [
  Validators.min(0),
  Validators.max(100),
  Validators.pattern(PL_ONLY_NUMBER_REGEX),
];

export const plTimeValidators: ValidatorFn[] = [
  Validators.required,
  Validators.pattern(PL_TIME_REGEX),
];

export const plNotEmptyValidators = [Validators.required, plNotBlankValidator];

export * from './not-blank.validator';
export * from './valid-option.validator';
export * from './date.validator';
